import type React from 'react';
import { createZustandContext } from './ZustandContext';

export type OrderMenuContextValue = {
  getItemMenuButtonProps: (
    extra: React.HTMLAttributes<Element>,
  ) => React.HTMLAttributes<Element>;
};

export const OrderMenuContext = createZustandContext<OrderMenuContextValue>();
